import { AxiosResponse } from 'axios'
import { RequestREAD } from 'services/Instances'

export const ItemProductServices = () => {
  const path = 'ItemProduto'

  const GetItemProductsByCdContract = async (
    cdContrato: string
  ): Promise<AxiosResponse<ItemProdutoContratoResponseDto[]>> =>
    await RequestREAD.get(`${path}/GetByCodContrato/${cdContrato}`)

  return { GetItemProductsByCdContract }
}

export interface ItemProdutoContratoResponseDto {
  idItemProduto: number
  cdOrdemItem: number
  hierarquiaProdutoId: number
  codHierarquiaProduto: string
  descHierarquiaProduto: string
  grupoMercadoriaId: number
  codGrupoMercadoria: string
  descGrupoMercadoria: string
  descCentroPlanta: string
  centroPlantaId: number
  contratoId: number
}
